import { createFileRoute } from '@tanstack/react-router'
import { MonitoringOverview } from '@/features/monitoring/overview'

export const Route = createFileRoute('/_authenticated/monitoring/')({
  component: MonitoringOverview,
})

